<template>
  <div id="app">
    <div class="scroll-container">
      <div v-if="isStandalone" class="iframe-wrapper">
        <iframe
          v-if="App_URL"
          :src="App_URL"
          class="masked-iframe"
          :allow="iframeAllowPolicy"
          allowfullscreen
        ></iframe>
      </div>
      <transition v-else>
        <RouterView />
      </transition>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
// import { PWARewardAPI } from './api/user';
import { getPWADomainInfo } from './api/common';

const isStandalone = ref(false);
const App_URL = ref('');

const iframeAllowPolicy = computed(() => {
  const features = ['web-share', 'fullscreen'];
  if (!App_URL.value) {
    return features.join('; ');
  }
  try {
    const origin = new URL(App_URL.value).origin;
    return [`camera ${origin}`, `microphone ${origin}`, ...features].join('; ');
  } catch {
    return ['camera *', 'microphone *', ...features].join('; ');
  }
});

onMounted(() => {
  // Detect standalone
  if (window.matchMedia("(display-mode: standalone)").matches) {
    isStandalone.value = true;
  } else if ((window.navigator as any).standalone) {
    // iOS Safari PWA
    isStandalone.value = true;
  }

  // React to changes
  window.matchMedia("(display-mode: standalone)")
    .addEventListener("change", (e) => {
      isStandalone.value = e.matches;
    });

  // 🔹 Detect PWA installation and refresh
  window.addEventListener("appinstalled", () => {
    console.log("✅ PWA was installed");
    window.location.reload(); // refresh app instantly
    if (localStorage.getItem('token') && localStorage.getItem('clientId')) {
      pwaCliam()
    }
    clearAuthData();
  });
});

const pwaCliam = () => {
  // PWARewardAPI().then(res => {
    console.log("claim success: ");
  //   clearAuthData();
  // }).catch(err => {
  //   console.log("claim err: ", err);
  //   clearAuthData();
  // })
}


const getPWAInfo = () => {
  getPWADomainInfo().then(res => {
    let domain = res.data.websiteDomain
    if (domain && !domain.startsWith("http")) {
      domain = "https://" + domain
    }
    App_URL.value = domain
  }).catch(err => {
    console.log("claim err: ", err);

  })
};
const clearAuthData = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("clientId");
  localStorage.removeItem("tenantId");
};


onMounted(() => {
  getPWAInfo()
})
</script>

<style>
.iframe-wrapper {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  position: relative;
}

.masked-iframe {
  display: block;
  width: 100%;
  max-width: 100%;
  height: 100%;
  border: 0;
  overflow: hidden;
  box-sizing: border-box;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.masked-iframe::-webkit-scrollbar {
  display: none;
}

.scroll-container {
  height: 100%;
  overflow: hidden;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none;
}

html,
body {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

#app {
  position: fixed;
  width: min(30rem, 100%);
  max-width: 100%;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  overflow-x: hidden;
  overflow-y: hidden;
  background: #fff;
  background-size: cover;
  background-repeat: repeat;
}

@media (min-width: 1440px) {
  #app {
    width: 30rem;
  }
}

@media (min-width: 1920px) {
  #app {
    width: 35rem;
  }
}

.scroll-container {
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.5s ease;
  position: absolute;
  width: 100%;
}

.slide-left-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-enter-to {
  transform: translateX(0%);
  opacity: 1;
}

.slide-left-leave-from {
  transform: translateX(0%);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(-30%);
  opacity: 0;
}

.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}

.ql-align-left {
  text-align: left;
}

@media screen and (max-width: 768px) {
  #app {
    width: 100%;
    max-width: 100%;
    left: 0;
    transform: none;
    -webkit-transform: none;
  }
}
</style>
